import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'syr-terms-page',
  templateUrl: './terms-page.component.html',
  styleUrls: ['./terms-page.component.scss']
})
export class TermsPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
